import * as Yup from "yup";

export const schemaDOA = Yup.object().shape({
  email_angel: Yup.string().test(
    "is email",
    "E-mail inválido.",
    (value, context) => value.split("@")[1] === "stone.com.br"
  ),
});
